import React, { useRef } from 'react'
import { noop } from 'lodash-es'
import Tick from './Tick'
import { useGesture } from './GestureProvider'
import { DragEventData } from '../types/gesture-types'
import { Cursor, TickDefinition } from '../types/types'

type BackgroundProps = {
  width: number
  height: number
  cursor: Cursor
  axisX: number
  axisY: number
  ticks: TickDefinition[]
  offset: number
  onPanStart: (event: DragEventData) => void
  onPanMove: (event: DragEventData) => void
  onPanEnd: (event: DragEventData) => void
}

const Background: React.FC<BackgroundProps> = props => {
  const {
    ticks,
    offset,
    width = 0,
    height = 0,
    cursor = 'auto',
    axisX = 0,
    axisY = 0,
    onPanStart = noop,
    onPanMove = noop,
    onPanEnd = noop,
  } = props

  const ref = useRef(null)
  const { bindGesture, isDragging } = useGesture()

  // Use our gesture context to bind gesture handlers
  const bind = bindGesture(
    {
      onDragStart: ({ event }) => {
        onPanStart({ event })
      },
      onDragMove: ({ event, deltaX, deltaY }) => {
        onPanMove({
          event,
          deltaX,
          deltaY,
        })
      },
      onDragEnd: ({ event }) => {
        onPanEnd({ event })
      },
    },
    {
      axis: 'x',
    }
  )

  const getTicksContent = () => {
    return ticks.map(function (tick) {
      const { label, key, type, xPos } = tick
      const actualX = offset + xPos
      if (actualX < width) {
        return <Tick label={label} x={actualX} size={type} key={key} />
      } else {
        return null
      }
    })
  }

  const backgroundStyle: React.CSSProperties = {
    width,
    height,
    cursor,
    touchAction: 'pan-y', // allow vertical scrolling, but prevent horizontal browser gestures
    userSelect: isDragging ? 'none' : 'auto', // disable text selection during dragging
  }
  const axisStyle: React.CSSProperties = {
    left: axisX,
    top: axisY,
  }
  const ticksContent = getTicksContent()
  return (
    <div className="background" style={backgroundStyle} ref={ref} {...bind()}>
      <div className="axis" style={axisStyle}>
        {ticksContent}
      </div>
    </div>
  )
}

export default Background
